import React from 'react';
import styled from 'styled-components';

import { CurrentTheme, CurrentLang, MagstimDropdown, MagstimInformationCard } from "common";
import { Button, Row, Col, InputGroup,  Label, DropdownItem } from 'reactstrap';

import styledMagstimTabsWrapper from 'common/controls/StyledMagstimTabsWrapper'

import { patientAnalyticsRoutesBase, patientRoute, accuracyRoute, assessmentsRoute, mtHistoryRoute, treatmentsRoute, reportRoute, detailsRoute } from 'routes';
import * as CsvUtils from 'common/utils/CsvUtils';

class MagstimAnalyticsDetailViewBase extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            buttonsDisabled: false,
            summaryClassType:undefined,
            tableHeight: 'calc(100vh - 340px)',
            apiData:undefined,
            pageAnalyticsName:'',
            detailData:{},
            detailName:"",
            detailHelpText:"",
            detailGuid:undefined,
            exportFileName: undefined,
            pageBaseRoute: patientAnalyticsRoutesBase,
            detailRoute:patientRoute,
            selectedFilter: undefined,
            filterIcon: 'fas fa-calendar-alt',
            filterOptions: []
        };

        this._summaryTable = React.createRef();
    }

    onShowAccuracy = () => {
        this.props.history.push({ pathname: `${this.state.pageBaseRoute}/${this.state.detailRoute}/${this.state.detailGuid}/${accuracyRoute}` })
    }

    onShowAssessments = () => {
        this.props.history.push({ pathname: `${this.state.pageBaseRoute}/${this.state.detailRoute}/${this.state.detailGuid}/${assessmentsRoute}` })
    }

    onShowMTHistory = () => {
        this.props.history.push({ pathname: `${this.state.pageBaseRoute}/${this.state.detailRoute}/${this.state.detailGuid}/${mtHistoryRoute}` })
    }

    onShowTreatmentHistory = () => {
        this.props.history.push({ pathname: `${this.state.pageBaseRoute}/${this.state.detailRoute}/${this.state.detailGuid}/${treatmentsRoute}` })
    }

    onShowTreatmentHistory = () => {
        this.props.history.push({ pathname: `${this.state.pageBaseRoute}/${this.state.detailRoute}/${this.state.detailGuid}/${treatmentsRoute}` })
    }

    onShowDetails = () => {
        this.props.history.push({ pathname: `${this.state.pageBaseRoute}/${this.state.detailRoute}/${this.state.detailGuid}/${detailsRoute}` })
    }

    onShowReport = () => {
        this.props.history.push({
            pathname: `${this.state.pageBaseRoute}/${reportRoute}`,
            state: { Guids: [this.state.detailGuid] }
        })
    }

    onClickExportSummary = () =>{
        if(this._summaryTable !== undefined && this._summaryTable !== null){
            CsvUtils.downloadAsCSV(document, this.state.exportFileName, undefined, this._summaryTable.current.getNamedValuePairs(this.state.detailData));
        }
    }

    onSelectFilter = (id) => {
        this.setState({ selectedFilter: id }, () => this.onFilterChanged())
    }

    componentDidMount() {
        this.loadDataFromAPI();
    }

    componentWillUnmount(){
		this.props.setBreadcrumbItem("", "");
    }

    handleError(error) {
        console.log(error);
        if (this.props.handleError !== undefined) {
            this.props.handleError(error);
        }
    }

    init(data) {

        if(data.RmtLevelsItems !== null && data.RmtLevelsItems !== undefined){
            // Just set the filter here and save the data in the state
            var filterOptions = [];
            var selectedFilter = this.state.selectedFilter;

            for (var item in data.RmtLevelsItems) {
                filterOptions.push(item);
            }

            // Default to the first option 
            if (selectedFilter === undefined && filterOptions.length > 0) {
                selectedFilter = filterOptions[0];
            }

            this.setState({ apiData: data, filterOptions: filterOptions, selectedFilter: selectedFilter }
                , () => {
                    this.onFilterChanged();
                });
        }
       
    }

    getFilterHeaderItems(){
        
        let filterHeaderItems = [];

        for(var index = 0; index < this.state.filterOptions.length; index++ ){
 
            const  item = <DropdownItem id={this.state.filterOptions[index]} key={this.state.filterOptions[index]}>{CurrentLang()[`filter_option_${this.state.filterOptions[index].toLowerCase()}`]}</DropdownItem>
            
            filterHeaderItems.push(item);

            if(index === 0){
                filterHeaderItems.push(<DropdownItem key="divider" divider />);
            }
        }

        return filterHeaderItems;
    }

    getRmtLevelsItemsSummary(data){
        var rmtLevelsItemsSummary = [];

        if (data.RmtLevelsItems[this.state.selectedFilter] !== undefined && data.RmtLevelsItems[this.state.selectedFilter] !== null) {
            if (data.RmtLevelsItems[this.state.selectedFilter].Summary !== undefined && data.RmtLevelsItems[this.state.selectedFilter].Summary !== null) { 
                rmtLevelsItemsSummary = data.RmtLevelsItems[this.state.selectedFilter].Summary;
    
                if (rmtLevelsItemsSummary.MotorThresholds > 0) {
                    rmtLevelsItemsSummary.AverageMTLevel = (rmtLevelsItemsSummary.SumMTLevel / rmtLevelsItemsSummary.MotorThresholds).toFixed(1) + '%';
                }
            }  
        }

        return rmtLevelsItemsSummary;
    }
   
    getClinicalAssessmentScoresItemsSummary(data){
        var clinicalAssessmentScoresItemsSummary = [];

        if (data.ClinicalAssessmentScoresItems[this.state.selectedFilter] !== undefined && data.ClinicalAssessmentScoresItems[this.state.selectedFilter] !== null) {
            if (data.ClinicalAssessmentScoresItems[this.state.selectedFilter].Summary !== undefined && data.ClinicalAssessmentScoresItems[this.state.selectedFilter].Summary !== null) { 
                clinicalAssessmentScoresItemsSummary = data.ClinicalAssessmentScoresItems[this.state.selectedFilter].Summary;
            }  
        }

        return clinicalAssessmentScoresItemsSummary;
    }

    getPatientAccuracyItemsSummary(data){
        var patientAccuracyItemsSummary = [];

        if (data.TreatmentAccuracyItems[this.state.selectedFilter] !== undefined && data.TreatmentAccuracyItems[this.state.selectedFilter] !== null) {
            if (data.TreatmentAccuracyItems[this.state.selectedFilter].Summary !== undefined && data.TreatmentAccuracyItems[this.state.selectedFilter].Summary !== null) { 
                patientAccuracyItemsSummary = data.TreatmentAccuracyItems[this.state.selectedFilter].Summary;
    
                if (patientAccuracyItemsSummary.SumPulses > 0) {
                    patientAccuracyItemsSummary.AveragePulsesWithinTolerance = (100* (patientAccuracyItemsSummary.SumPulsesWithinTolerance / patientAccuracyItemsSummary.SumPulses)).toFixed(0) + '%';
                }
            }  
        }

        return patientAccuracyItemsSummary;
    }

    getTreatmentCountSummary(data){
        var treatmentCountItemsSummary = [];

        if(data.TreatmentCount !== null && data.TreatmentCount !== undefined){
            if (data.TreatmentCount[this.state.selectedFilter] !== undefined && data.TreatmentCount[this.state.selectedFilter] !== null) {
                if (data.TreatmentCount[this.state.selectedFilter].Summary !== undefined && data.TreatmentCount[this.state.selectedFilter].Summary !== null) { 
                    treatmentCountItemsSummary = data.TreatmentCount[this.state.selectedFilter].Summary;
                }  
            }
        }

        return treatmentCountItemsSummary;
    }

    getSummaryAreaContent = () => {

        var summaryExportButton = <>
            <Col className="pt-1 pr-4 mt-3 mr-3 mb-3 text-right">
                <Button color="primary" 
                        className="pl-5 pr-5"  
                        disabled={this.state.isLoading} 
                        onClick={this.onClickExportSummary} 
                        size={CurrentTheme().ControlSize} >
                            <i className="fas fa-file-excel pr-2"></i> {CurrentLang().table_export_title}
                </Button>
            </Col>
        </>

        var summaryTable = <></>;

        if(this.state.summaryClassType !== undefined)
        {
            summaryTable =  React.createElement(this.state.summaryClassType, { key: this.state.detailData, data: this.state.detailData, ref: this._summaryTable }, null)
        }
       
        return  <div className="table-area mt-2 mb-2">
                    {summaryTable}
                    {summaryExportButton}
                </div>
    }

    getAnalyticsButtons = () => {
        alert(' Override in derived class');
    }

    render() {


        // Set all the layout elements as variable 
        let filterHeaderItems = this.getFilterHeaderItems();

        var dropdownFilter = <MagstimDropdown id="filterDropdown" ref={this._filter} onSelect={this.onSelectFilter} icon={this.state.filterIcon} dropDownKey={this.state.selectedFilter}>
                               {filterHeaderItems}
                             </MagstimDropdown>

       return (
           <Wrapper className="ml-3 mr-3" tableHeight={this.state.tableHeight}>

               <Row className="ui-main">
                   <Col>
                       <Row>
                           <Col lg="8" md="12" className="mb-2">
                               <MagstimInformationCard title={this.state.detailName} dropdownFilter={dropdownFilter}>
                                   {this.getSummaryAreaContent()}
                               </MagstimInformationCard>
                           </Col>

                           <Col lg="4" md="12" className="mb-2" >
                               <MagstimInformationCard title={this.state.pageAnalyticsName} >
                                   <div id="top-align" className="w-100">

                                       <InputGroup>
                                           <Label>{this.state.detailHelpText}</Label>
                                           {this.getAnalyticsButtons()}
                                       </InputGroup>
                                   </div>
                               </MagstimInformationCard>
                           </Col>
                       </Row>
                   </Col>
               </Row>

           </Wrapper>
       );
   }
   
}

const Wrapper = styled(styledMagstimTabsWrapper)`

#top-align { 
	padding-top:30px; 
} 

#top-align .btn  {
	width: 100%;
	margin-bottom: 15px;
	margin-left:30px;
	margin-right:30px;
	box-shadow: 0px 2px 5px rgba(0,0,0,0.2);
}


#top-align label {
	width: 100%;
	margin-bottom: 15px;
	margin-left:30px;
	margin-right:30px;
}

`

export default MagstimAnalyticsDetailViewBase;